import { render, staticRenderFns } from "./picShare.vue?vue&type=template&id=03ae1229&scoped=true&"
import script from "./picShare.vue?vue&type=script&lang=js&"
export * from "./picShare.vue?vue&type=script&lang=js&"
import style0 from "./picShare.vue?vue&type=style&index=0&id=03ae1229&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ae1229",
  null
  
)

export default component.exports